import { allTrackers } from "app/services/track/track";

import createOnboardingHubTrackingService from "./factory";

const onboardingHubTrackingService = createOnboardingHubTrackingService(
    allTrackers.dispatchTrackEvent.bind(allTrackers),
);

export default onboardingHubTrackingService;
